import { BriefcaseIcon, BuildingIcon, CarIcon, HotelIcon, HouseIcon, LeafIcon, StoreIcon, TreesIcon, WarehouseFullIcon, } from '@gemini/icons';
export const propertyData = [
    {
        image: HouseIcon,
        description: 'House',
        value: 'HOUSE',
        label: '',
    },
    {
        image: BuildingIcon,
        description: 'Apartment',
        value: 'APARTMENT',
        label: '',
    },
    {
        image: TreesIcon,
        description: 'Plot',
        value: 'PLOT',
        label: '',
    },
    {
        image: BriefcaseIcon,
        description: 'Office',
        value: 'OFFICE',
        label: '',
    },
    {
        image: StoreIcon,
        description: 'Gastronomy',
        value: 'GASTRONOMY_HOTEL',
        label: '',
    },
    {
        image: WarehouseFullIcon,
        description: 'Storage',
        value: 'STORAGE_PRODUCTION',
        label: '',
    },
    {
        image: LeafIcon,
        description: 'Agriculture',
        value: 'AGRICULTURE_FORESTRY',
        label: '',
    },
    {
        image: CarIcon,
        description: 'Parking',
        value: 'PARKING',
        label: '',
    },
    {
        image: HotelIcon,
        description: 'Miscellaneous',
        value: 'MISCELLANEOUS',
        label: '',
    },
];
